import SharesDistribution from './container';

export default SharesDistribution;
